import { render, staticRenderFns } from "./Prescriber.vue?vue&type=template&id=6a82eece&scoped=true"
import script from "./Prescriber.vue?vue&type=script&lang=js"
export * from "./Prescriber.vue?vue&type=script&lang=js"
import style0 from "./Prescriber.vue?vue&type=style&index=0&id=6a82eece&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a82eece",
  null
  
)

export default component.exports